import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function contactValidator(
  control: AbstractControl
): ValidationErrors | null {
  const isValidValue = control?.value?.isValid;
  return isValidValue === undefined || isValidValue
    ? null
    : { invalidContact: true };
}
